@if (config.type == 'info') {
  <div class="iconAndText mat-accent">
    <mat-icon>info</mat-icon>
    <span>{{ config.message }}</span>
  </div>
}

@if (config.type == 'error') {
  <div class="iconAndText mat-error">
    <mat-icon>report_problem</mat-icon>
    <span>{{ config.message }}</span>
  </div>
}

@if (config.type == 'link') {
  <div class="iconAndText mat-error">
    <mat-icon>report_problem</mat-icon>
    <span (click)="openInNewWindow()">{{ config.message }}
      <mat-icon>open_in_new</mat-icon></span>
      <span (click)="dismiss()">
        <mat-icon>close</mat-icon>
      </span>
    </div>
  }


